<ph-stack [formGroup]="formatForm">
    <ph-card heading="Optional printed check fields" flat>
        <ph-toolbar>
            <ph-field inline>
                <ph-checkbox formControlName="displayBankAccount" ngDefaultControl aria-label="Bank account"></ph-checkbox>
                <ph-label>Bank account</ph-label>
            </ph-field>
            <ph-field inline>
                <ph-checkbox formControlName="displayPayor" ngDefaultControl aria-label="Name and address"></ph-checkbox>
                <ph-label>Name and address</ph-label>
            </ph-field>
            <ph-field inline>
                <ph-checkbox formControlName="displayCheckNumber" ngDefaultControl aria-label="Check number"></ph-checkbox>
                <ph-label>Check number</ph-label>
            </ph-field>
            <ph-field inline>
                <ph-checkbox formControlName="displayMemo" ngDefaultControl aria-label="Memo and signature"></ph-checkbox>
                <ph-label>Memo and signature</ph-label>
            </ph-field>
            <ph-field inline>
                <ph-checkbox formControlName="displayVendorAddress" ngDefaultControl aria-label="Vendor address"></ph-checkbox>
                <ph-label>Vendor address</ph-label>
            </ph-field>
        </ph-toolbar>
    </ph-card>

    <ph-card heading="Printed check format" flat>
        <mat-radio-group formControlName="format"> <!-- kitlint-allow-legacy: ph-radio-group items are {value,label,disabled} only — no slot for the sample check image beside each option. Kit gap, see report. -->
            <ph-columns min="200px">
                <div>
                    <mat-radio-button [value]="FORMAT_ONE_PER_PAGE">
                        <span>One per page</span>
                    </mat-radio-button>
                    <img src="assets/images/app/check_voucher_1.png" class="img-fluid" alt="Check Voucher">
                </div>
                <div>
                    <mat-radio-button [value]="FORMAT_THREE_PER_PAGE">
                        <span>Three per page</span>
                    </mat-radio-button>
                    <img src="assets/images/app/check_voucher_3.png" class="img-fluid" alt="Check Voucher">
                </div>
            </ph-columns>
        </mat-radio-group>
    </ph-card>
</ph-stack>
